module.exports = "  <div class=\"ui three column grid\">\n  <ng-container *ngFor=\"let image of images; let i=index\">\n  <div class=\"column\">\n    <div class=\"ui segment\">\n      <div class = \"background\" style = \"background-image: url(https://www.amcharts.com/wp-content/uploads/2014/03/demo_4074_light.jpg);\" (click)=\"open(i)\">\n          <h4>{{image['caption']}}</h4>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/src/app/student/student.component.html
// module id = ../../../../../src/app/student/student.component.html
// module chunks = 0